<div class="content">
    <h2 data-qa="tnb-sub-header">Planwerte</h2>

    <redispatch-planwert-list></redispatch-planwert-list>
</div>

